import { requiredRule, getRuleLen } from '../../../../utils/rules';
import React from 'react';
import { Form, Input, InputNumber, Selector, Icon } from '@roo/roo';
import { FieldList } from '../../_components/FieldList';

const { Field } = Form;
const { Textarea } = Input

export const Budget = function (props) {
  const { values, validateField } = props
  const budgetType = [
    { label: '咨询费', value: '咨询费' },
    { label: '交通费', value: '交通费' },
    { label: '差旅费', value: '差旅费' },
    { label: '劳务费', value: '劳务费' },
    { label: '设备费', value: '设备费' },
    { label: '材料费', value: '材料费' },
    { label: '测试化验加工费', value: '测试化验加工费' },
    { label: '审计费', value: '审计费' },
    { label: '不可预见费', value: '不可预见费' },
    { label: '其他商品和服务支出', value: '其他商品和服务支出' },
  ]
  return (
    <div className='form-patch'>
      <Field
        required={true}
        rule={{
          validator: (rule, value, callback) => {
            validateField('budgetApply');
            if ((value ?? 'null') === 'null') {
              return callback('这是必填项')
            }
            return callback()
          }
        }}
        name={`budgetOverall`}
        placeholder={'请输入数字（可输入小数点），若无则填0'}
        label='项目总预算'
      >
        {({ value, handleChange, disabled }) => {
          return (
            <>
              <InputNumber value={value} onChange={handleChange} disabled={disabled} style={{ width: '100%' }} className={'prefix-w'} max={9999999} min={0} placeholder={'请输入数字（可输入小数点），若无则填0'}></InputNumber>

            </>
          );
        }}
      </Field>
      <Field
        required={true}
        rule={{
          validator: (rule, value, callback) => {
            if ((value ?? 'null') === 'null') {
              return callback('这是必填项');
            }
            if (values?.budgetOverall < (value * 2)) {
              return callback('已超出项目总预算的50%')
            }
            if (value > 300) return callback('申请示范项目经费<=300万');
            return callback();
          },
        }}
        name={`budgetApply`}
        placeholder={'请输入数字（可输入小数点），若无则填0'}
        cols={{ label: { span: 3 }, field: { span: 9 } }}
        label='申请示范项目经费'
      >
        {({ value, handleChange, disabled }) => {
          return (
            <>
              <InputNumber value={value} onChange={handleChange} disabled={disabled} style={{ width: '100%' }} className={'prefix-w'} max={9999999} min={0} placeholder={'请输入数字（可输入小数点），若无则填0'}></InputNumber>
              <div className='t-info' style={{ marginBottom: '2px' }}>
                <Icon name='info-circle-o' />
                申请示范项目经费应小于等于项目总预算的50%
              </div>
              <div className='t-info' style={{ marginBottom: '2px' }}>
                <Icon name='info-circle-o' />
                申请示范项目经费应不超过300万元
              </div>
            </>
          );
        }}
      </Field>
      <Field
        required={true}
        rule={getRuleLen(500, true)}
        name={`otherBudgetExplanation`}
        label='其他费用'
        as={
          <Textarea
            maxLength={500}
            placeholder={'请说明项目总预算中，其他经费的来源。比如单位自筹、银行贷款等。'}
          />
        }
      />

      <div className={'cert-table'}>
        <div className={'c-title'}>预计支出内容</div>
        <div className={'c-title'}>支出项目类别</div>
        <div className={'c-title'}>预计支出金额</div>
      </div>
      <FieldList
        {...props}
        name={`budgetList`}
        maxCount={30}
        minCount={1}
        // iniData={personInfoObj}
        plusText={`添加经费支出预算表（仅列申请示范项目的经费部分）`}
        itemClassName={`form-patch budget-table`}
        itemStyle={{ display: 'flex', padding: 0, margin: 0 }}
      >
        <Field
          rule={getRuleLen(20, true)}
          name='item'
          cols={{ label: { span: 0 } }}
          as={<Input maxLength={20} placeholder={`请输入`} />}
        />
        <Field
          name={`type`}
          cols={{ label: { span: 0 } }}
          rule={getRuleLen(50, true)}
          as={<Selector style={{ width: "220px" }} options={budgetType} filterable disablePortal />}
        />
        <Field
          rule={{ ...requiredRule, type: 'number' }}
          name={`amount`}
          cols={{ label: { span: 0 } }}
          as={<InputNumber className={'suffix-input'} style={{ width: "220px" }} vertical min={0} max={9999999} placeholder='0.00' ></InputNumber>}
        />
      </FieldList>
      <Field
        required={true}
        rule={getRuleLen(500, true)}
        name={`budgetExplanation`}
        label='预算说明（仅列申请示范项目的经费部分）'
        as={
          <Textarea
            maxLength={500}
            placeholder={
              '对本项目上述预算表中直接费用各科目支出主要用途、与项目的相关性、必要性及测算方法、测算依据进行详细说明（含数量、单价、价格依据等），不得简单按比例编列。'
            }
          />
        }
      />
      <br />
    </div>
  );
};
